<dx-popup [showTitle]="true" [width]="480" height="auto" visible="true" title="Password scaduta"
    [hideOnOutsideClick]="false" [showCloseButton]="false">
    <div style="padding: 25px;">
        <app-ildato-aggiorna-password 
            [username]="username" 
            [parametriPasswords]="parametriPasswords" 
            (ilDatoAggiornaPasswordEventEmitter)="onIlDatoAggiornaPasswordEvent($event)">
        </app-ildato-aggiorna-password>
    </div>
    
</dx-popup>
